export enum FilterType {
  CHECKBOX = 'CHECKBOX',
  DATEPICKER = 'DATEPICKER',
  RADIO = 'RADIO',
  RADIO_DATEPICKER = 'RADIO_DATEPICKER',
  TEXT = 'TEXT',
}
